import { Oauth1ProviderData } from "@istari/istari-client";

import { Oauth1ProviderConfig } from "../../model/oauth1-provider-config";

// Assign by name onto the instance: positional ctor args would misroute on an SDK regen reorder,
// and an untyped Object.assign would silently drop a renamed field.
export function toOauth1ProviderData(config: Oauth1ProviderConfig): Oauth1ProviderData {
  // OAuth 1.0a has no standard endpoint discovery, so a config with neither the three endpoints
  // nor a discovery document can never complete a token exchange — refuse to serialize one rather
  // than let a non-form caller ship it to the backend.
  const endpointsResolvable =
    Boolean(config.rootservicesPath) ||
    Boolean(config.requestTokenEndpoint && config.authorizationEndpoint && config.accessTokenEndpoint);
  if (!endpointsResolvable) {
    throw new Error("OAuth 1.0a provider config needs its three endpoints, or a discovery document to read them from");
  }
  const data = new Oauth1ProviderData(config.baseUrl, config.consumerKey);
  data.requestTokenEndpoint = config.requestTokenEndpoint;
  data.authorizationEndpoint = config.authorizationEndpoint;
  data.accessTokenEndpoint = config.accessTokenEndpoint;
  data.rootservicesPath = config.rootservicesPath;
  data.identityPath = config.identityPath;
  data.extraTokenHeaders = config.extraTokenHeaders;
  data.twoLeggedEmptyToken = config.twoLeggedEmptyToken;
  data.authChallengeHeaders = config.authChallengeHeaders;
  data.tlsCaPem = config.tlsCaPem;
  data.tlsVerify = config.tlsVerify;
  return data;
}
